import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getDatabase } from "firebase/database";
import { getAnalytics } from "firebase/analytics";
import { getModoDev } from "../data/memory";

const firebaseConfigProd = {
  apiKey: "AIzaSyBZVOulBxmPLxT2LQdcMUz20U4ieND0U-o",
  authDomain: "paralelas-bt.firebaseapp.com",
  databaseURL: "https://paralelas-bt-default-rtdb.firebaseio.com",
  projectId: "paralelas-bt",
  storageBucket: "paralelas-bt.firebasestorage.app",
  messagingSenderId: "646079705794",
  appId: "1:646079705794:web:cc105c0db60cb08e34815b",
  measurementId: "G-BNBXLZWQRR",
};

const firebaseConfigDev = {
  apiKey: "AIzaSyCBZxT-AE_4XtIxBYVzjwypvLQzpaqZguI",
  authDomain: "paralelasteste.firebaseapp.com",
  databaseURL: "https://paralelasteste-default-rtdb.firebaseio.com",
  projectId: "paralelasteste",
  storageBucket: "paralelasteste.firebasestorage.app",
  messagingSenderId: "989791121088",
  appId: "1:989791121088:web:ae78d552be20942962c725",
  measurementId: "G-PGX4J2KJGK",
};
// Switch entre dev e prod
const app = initializeApp(
  getModoDev() ? firebaseConfigDev : firebaseConfigProd
);

export const firebaseAuth = getAuth(app);
export const db = getDatabase(app);

// Só chama Analytics se estiver no navegador
if (typeof window !== "undefined") {
  getAnalytics(app);
}

export default app;
